import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Flex,
  Text,
  Grid,
  GridItem,
  Switch,
  Card,
} from "@chakra-ui/react";

import { anim_portfolio } from "../../info/anim_info";
import PortfolioPick from "../WorkPages/PortfolioPick";
import ArtItem from "./ArtItem";

export default function Art() {
  const [activeIdx, setActiveIdx] = useState<number>(0);
  return (
    <div id="art" style={{ scrollSnapType: "y" }}>
      <Flex
        scrollSnapType={"y"}
        flexDir={"column"}
        bgAttachment="fixed"
        bgSize="cover"
        backgroundColor="rgba(245, 243, 239, 1)"
      >
        <Grid
          scrollSnapType="y"
          templateAreas={{
            lg: `"header main"
                    "control main"`,
            base: `"header"
              "control"
              "main"`,
          }}
          gridTemplateRows={{ lg: "8rem 1fr", base: "10vh 0rem 75vh" }}
          gridTemplateColumns={{ lg: "1fr 3fr", base: "1fr" }}
          py="5rem"
          pl={{ lg: "8rem", base: "auto" }}
          height="100vh"
        >
          <GridItem area={"header"}>
            <Text
              variant={"subHeader"}
              textAlign="center"
              lineHeight="90%"
              color="darkestgrey"
            >
              Animation Portfolio
            </Text>
          </GridItem>
          <GridItem
            area={"control"}
            display={{ lg: "flex", base: "none" }}
            flexDir="column"
            justifyContent="flexStart"
            alignItems="center"
            height="100%"
            p="0"
          >
            <Flex
              alignItems="center"
              justifyContent="center"
              flexDir={"column"}
              width="70%"
              _hover={{
                width: "100%",
              }}
              transition="all 1s ease"
            >
              {anim_portfolio.map((p, i) => (
                <PortfolioPick
                  title={p.title}
                  year={null}
                  active={activeIdx == i}
                  idx={i}
                  setActiveIdx={setActiveIdx}
                />
              ))}
            </Flex>
          </GridItem>
          <GridItem
            area={"main"}
            display="flex"
            alignItems={{ base: "center", lg: "flex-end" }}
            flexDir={"column"}
            overflowX={"hidden"}
          >
            <ArtItem
              title={anim_portfolio[activeIdx].title}
              desc={anim_portfolio[activeIdx].desc}
              link={anim_portfolio[activeIdx].link}
              linkLabel={anim_portfolio[activeIdx].linkLabel}
              role={anim_portfolio[activeIdx].role}
              tags={anim_portfolio[activeIdx].tags}
              image={anim_portfolio[activeIdx].image}
              bullets={anim_portfolio[activeIdx].bullets}
              activeIdx={activeIdx}
              setActiveIdx={setActiveIdx}
            />
            <Flex
              alignItems={"center"}
              justifyContent={"center"}
              width="90%"
              gap="2rem"
            >
              <Button
                variant="outlineSmall"
                color="lightblue"
                borderColor="lightblue"
                _hover={{ borderColor: "black", color: "black" }}
                onClick={(c) => {
                  if (activeIdx == 0) {
                    setActiveIdx(anim_portfolio.length - 1);
                  } else {
                    setActiveIdx(activeIdx - 1);
                  }
                }}
              >
                previous
              </Button>
              <Button
                variant="outlineSmall"
                color="lightblue"
                borderColor="lightblue"
                _hover={{ borderColor: "black", color: "black" }}
                onClick={(c) => {
                  if (activeIdx == anim_portfolio.length - 1) {
                    setActiveIdx(0);
                  } else {
                    setActiveIdx(activeIdx + 1);
                  }
                }}
              >
                next
              </Button>
            </Flex>
          </GridItem>
        </Grid>
      </Flex>
    </div>
  );
}
